module.exports = __webpack_public_path__ + "img/sky.17ce1e93.png";